import { render, staticRenderFns } from "./activitySignInDetail.vue?vue&type=template&id=13a72a2a&scoped=true&"
import script from "./activitySignInDetail.vue?vue&type=script&lang=js&"
export * from "./activitySignInDetail.vue?vue&type=script&lang=js&"
import style0 from "./activitySignInDetail.vue?vue&type=style&index=0&id=13a72a2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a72a2a",
  null
  
)

export default component.exports